import "styles/tokens.css";
import "index.css";
import App from "App";
import React from "react";
import { Amplify } from "aws-amplify";
import awsConfig from "aws/aws-exports";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));

try {
  Amplify.configure(awsConfig);
} catch (error) {
  console.error("Error configuring Amplify:", error);
}

// //Microsoft Clarity - Load conditionally based on environment variable
// if (process.env.REACT_APP_ENV === 'staging') {
//   (function(c,l,a,r,i,t,y){
//     c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
//     var t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
//     var y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
//   })(window, document, "clarity", "script", "ucj05airdf");
// }

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);